var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.495,
    height: 22.141,
    viewBox: "0 0 31.495 22.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page_back_web_app",
    "data-name": "Page back web app",
    d: "M10.273,5.009A1.117,1.117,0,0,1,11.86,6.58L3.813,14.627H30.367a1.118,1.118,0,0,1,1.127,1.111,1.131,1.131,0,0,1-1.127,1.127H3.813L11.86,24.9a1.139,1.139,0,0,1,0,1.587,1.112,1.112,0,0,1-1.587,0L.321,16.532a1.12,1.12,0,0,1,0-1.571Z",
    transform: "translate(0.001 -4.676)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowNew);
export default __webpack_public_path__ + "static/media/back-arrow-new.1763e659e5682e1b9032ccad70153f05.svg";
export { ForwardRef as ReactComponent };